import {
  UserWithTokenPairResponseType,
  WhiskyBudget,
  MemberType,
  ValueOfOption,
  SocialAuthProviderType,
  SocialAuthUserWithTokenPairResponseType,
} from '../types';
import {axiosClient} from '../axios';

// -- login --
export interface LoginWithEmailPayloadType {
  email: string;
  password: string;
}

export const loginWithEmail = async (
  formData: LoginWithEmailPayloadType,
): Promise<UserWithTokenPairResponseType> => {
  const {data} = await axiosClient.post<UserWithTokenPairResponseType>(
    '/auth/login/email/',
    formData,
  );
  return data;
};

export interface AuthRefreshPayloadType {
  refresh: string;
}

export const authRefresh = async (
  formData: AuthRefreshPayloadType,
): Promise<UserWithTokenPairResponseType> => {
  const {data} = await axiosClient.post<UserWithTokenPairResponseType>(
    '/auth/refresh/',
    formData,
  );
  return data;
};

export interface LoginWithMagicTokenPayloadType {
  magic_token: string;
}

export const loginWithMagicToken = async (
  formData: LoginWithMagicTokenPayloadType,
): Promise<UserWithTokenPairResponseType> => {
  const {data} = await axiosClient.post<UserWithTokenPairResponseType>(
    '/auth/login/magic/',
    formData,
  );
  return data;
};

// -- signup --
export interface SignupWithEmailStepOnePayloadType {
  email: string;
  password: string;
  is_terms_agreed: boolean;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  phone_number?: string;
  receive_marketing: boolean;
  recaptcha: string;
}

export const signupWithEmailStep1 = async (
  formData: SignupWithEmailStepOnePayloadType,
): Promise<UserWithTokenPairResponseType> => {
  const {data} = await axiosClient.post<UserWithTokenPairResponseType>(
    '/auth/signup/step1/email/',
    formData,
  );
  return data;
};

export interface SignupStepTwoPayloadType {
  postcode: string;
  whisky_budget: ValueOfOption<typeof WhiskyBudget>;
  whisky_purchase_frequency: string;
  preferred_communication_channels: string[];
}

export const signupStep2 = async (
  formData: SignupStepTwoPayloadType,
): Promise<MemberType> => {
  const {data} = await axiosClient.post<MemberType>(
    '/auth/signup/step2/',
    formData,
  );
  return data;
};

// --- Change password ---
export interface ChangePasswordPayloadType {
  current_password: string;
  new_password: string;
  new_password_confirmation: string;
}

export const changePassword = async (
  formData: ChangePasswordPayloadType,
): Promise<string> => {
  const {data} = await axiosClient.post<string>(
    '/auth/change-password/',
    formData,
  );
  return data;
};

// --- Forgot password ---
export interface ForgotPasswordPayloadType {
  email: string;
}

export const forgotPassword = async (
  formData: ForgotPasswordPayloadType,
): Promise<string> => {
  const {data} = await axiosClient.post<string>(
    '/auth/forgot-password/',
    formData,
  );
  return data;
};

export interface PasswordResetPayloadType {
  token: string;
  uid: string;
  new_password: string;
  new_password_confirmation: string;
}

export const resetPassword = async (
  formData: PasswordResetPayloadType,
): Promise<string> => {
  const {data} = await axiosClient.post<string>(
    '/auth/reset-password/',
    formData,
  );
  return data;
};

// --- Social Auth ---
export interface SocialAuthPayloadType {
  auth_provider: SocialAuthProviderType;
  token: string;
  user_id?: string;
  email?: string;
  name?: string;
  profile_picture_url?: string;
}

export const socialAuth = async (
  formData: SocialAuthPayloadType,
): Promise<SocialAuthUserWithTokenPairResponseType> => {
  const {data} =
    await axiosClient.post<SocialAuthUserWithTokenPairResponseType>(
      '/auth/social/',
      formData,
    );
  return data;
};
